<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/img-flow-config/table">图片流转配置列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">

            <el-form-item label="流转名称"
                          prop="name">
              <el-input v-model="form.name"
                        placeholder="请输入流转名称"></el-input>
            </el-form-item>

            <el-form-item label="所属客户"
                          prop="customer_id">
              <remote-select
                class="width-max"
                clearable
                id-key="number"
                label-key="name"
                value-key="id"
                placeholder="请输入客户关键字"
                v-model="form.customer_id"
                @change="(value) => { form.customer_name=value.name;form.project_id='';form.batch_id='';$refs.projectSelect.emptyOptions(); }"
                :query-request="getCustomerTable"
                :find-request="getCustomerDetail">
              </remote-select>
            </el-form-item>

            <el-form-item label="所属项目"
                          prop="project_id">
              <remote-select
                ref="projectSelect"
                class="width-max"
                clearable
                id-key="number"
                label-key="name"
                value-key="id"
                placeholder="请输入项目关键字"
                v-model="form.project_id"
                @change="(value) => { form.project_name=value.name;form.batch_id = '';$refs.batchSelect.emptyOptions(); }"
                :disabled="!form.customer_id"
                :query-request="(_)=>getProjectTable(Object.assign({customerid: form.customer_id}, _))"
                :find-request="getProjectDetail">
              </remote-select>
            </el-form-item>

            <el-form-item label="所属批次"
                          prop="batch_id">
              <remote-select
                ref="batchSelect"
                class="width-max"
                clearable
                id-key="number"
                label-key="detail"
                value-key="id"
                placeholder="请输入批次关键字"
                v-model="form.batch_id"
                :disabled="!form.project_id"
                :query-request="(_)=>getBatchTable(Object.assign({customerid: form.customer_id, projectid:form.project_id}, _))"
                :find-request="getBatchDetail"
                @change="(value) => { form.batch_name=value.detail||value.number }">
              </remote-select>
            </el-form-item>

            <el-form-item label="所属分步模板"
                          prop="step_template_id">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                label-key="title"
                value-key="id"
                placeholder="请输入分步任务模板关键字"
                v-model="form.step_template_id"
                :query-request="getStepTemplateTable"
                :find-request="getStepTemplateDetail"
                @change="stepTemplateChange">
              </remote-select>
            </el-form-item>
          </div>
        </div>

        <el-form-item label="模板识别题目"
                      prop="step_template_question_ids">
          <el-transfer
            filterable
            filter-placeholder="请输入题目关键字"
            v-model="form.step_template_question_ids"
            @change="changeQuestionIds"
            :data="questions"
            :titles="['未选', '已选']">
          </el-transfer>
        </el-form-item>

        <el-form-item label="图片拼接题目"
                      prop="splice_question_ids">
          <el-transfer
            filterable
            filter-placeholder="请输入题目关键字"
            v-model="form.splice_question_ids"
            :data="spliceQuestions"
            :titles="['未选', '已选']">
          </el-transfer>
        </el-form-item>

        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="识别模型"
                          prop="model_id">
              <remote-select
                class="width-max"
                clearable
                id-key="name"
                label-key="alias"
                value-key="id"
                placeholder="请输入模型关键字"
                v-model="form.model_id"
                :query-request="getImgFlowModelTable"
                :find-request="getImgFlowModelDetail">
              </remote-select>
            </el-form-item>
          </div>
        </div>

        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../img-flow-config.rules.js'

export default {
  components: {},
  data () {
    return {
      id: 0,
      formRules,
      form: {
        name: '',
        customer_id: '',
        customer_name: '',
        project_id: '',
        project_name: '',
        batch_id: '',
        batch_name: '',
        step_template_id: '',
        step_template_question_ids: [],
        splice_question_ids: [],
        model_id: '',
      },
      questions: [],
      spliceQuestions: [],
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map([
      'getImgFlowModelTable',
      'getImgFlowModelDetail',
      'getCustomerTable',
      'getCustomerDetail',
      'getProjectTable',
      'getProjectDetail',
      'getBatchTable',
      'getBatchDetail',
      'getStepTemplateTable',
      'getStepTemplateDetail',
    ]),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getImgFlowConfigDetail', {id}).then(({data}) => {
        request.page('getStepTemplateDetail', {id: data.step_template_id}).then(({data}) => {
          this.setQuestions(JSON.parse(data.json))
          this.changeQuestionIds()
        })
        data.customer_id = String(data.customer_id)
        data.project_id = String(data.project_id)
        data.batch_id = String(data.batch_id)
        data.step_template_id = String(data.step_template_id)
        filter.setLoop(this.form, data)
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createImgFlowConfigData', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/img-flow-config/table/'})
        })
      })
    },
    update (id) {
      request.common('updateImgFlowConfigData', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/img-flow-config/table/'})
        })
      })
    },
    stepTemplateChange (value) {
      this.questions = []
      this.form.step_template_question_ids = []
      return this.getStepTemplateDetail({id: value.id}).then(({data}) => {
        this.setQuestions(JSON.parse(data.json))
      })
    },
    setQuestions (questions) {
      this.questions = questions.map((question, index) => {
        return {
          key: question.stepId,
          label: 'Q' + (index + 1) + ' ' + question.title,
        }
      })
    },
    changeQuestionIds () {
      // 获得拼接题目列表
      let questions = []
      this.questions.forEach((question) => {
        if (this.form.step_template_question_ids.includes(question.key)) {
          questions.push(question)
        }
      })
      // 清除无效的已选选项
      let spliceIds = this.form.splice_question_ids.concat()
      spliceIds.forEach((id, index) => {
        if (!this.form.step_template_question_ids.includes(id)) {
          this.form.splice_question_ids.splice(index, 1)
        }
      })
      this.spliceQuestions = questions
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/img-flow-config/pages/ImgFlowConfigForm.vue